export const BOX_ID_KEY = 'VR_BOX_ID';
export const EXPIRING_LOCAL_DATA_KEY_PREFIX = 'EXPIRING_LOCAL_DATA_';
